import { atom } from "recoil"

export const contactReplyThreadConcatRequestIdState = atom({
  key: "atoms/contact/contactReplyThreadConcatRequestIdState",
  default: 0,
})
